module.exports = __webpack_public_path__ + "static/assets/79d588614c7827f6ac6620014b0eb078.svg";